module.exports = __webpack_public_path__ + "static/flags/MR-e9e26cbb865e19e119473ab69e7faac9.gif";